import { render, staticRenderFns } from "./RiskControlStatistics.vue?vue&type=template&id=39f6089e&scoped=true&"
import script from "./RiskControlStatistics.vue?vue&type=script&lang=js&"
export * from "./RiskControlStatistics.vue?vue&type=script&lang=js&"
import style0 from "./RiskControlStatistics.vue?vue&type=style&index=0&id=39f6089e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f6089e",
  null
  
)

export default component.exports